/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { isAddress } from '@ethersproject/address'
import { jsNumberForAddress } from 'react-jazzicon'

export const toSeedNumber = (address: string) => {
  try {
    isAddress(address)
  } catch (error: any) {
    throw new Error('Failed to get the seeder for supplied address.', {
      cause: error
    })
  }

  return jsNumberForAddress(address as string)
}
